export const getRouteParams = (name: string, value: string): URLSearchParams => {
  let routeParams = new URLSearchParams();
  routeParams.set(name, value);
  
  return routeParams;
}